export default __webpack_public_path__ + "static/media/mssql.2b14e66f.svg";